import React, {useState} from "react";
import Modal from "@mui/material/Modal";
import {getCryporCurrencyListHome} from "../apihelper/homepage";
import {Button, Grid, TextField, Card, Checkbox, } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import Typography from "@mui/material/Typography";
import json2mq from "json2mq";
import useMediaQuery from "@mui/material/useMediaQuery";
import {useNavigate} from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import CreatableSelect from "react-select/creatable";
import Alert from "@mui/material/Alert";
import {DialogTitle, DialogContent, DialogActions} from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import {getTotalunit, getFetchdropdown} from "../apihelper/cryptocurrencylist";
import {addToPortfolio, copyToPortfolio} from "../apihelper/portfolio";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {useEffect, useRef} from "react";
import {useLocation} from "react-router-dom";
import LoginPopUp from "../common/alert/login/LoginPopUp";

const AddToPortfolioPopup = ({triggerElement, slugName, headingText = "Add To Portfolio"}) => {

    const [user_role, setuser_role] = useState("");
    const navigate = useNavigate();
    const location = useLocation();
    const [portfolioTypeId, setPortfolioTypeId] = useState("");
    const [slugpopupdata, setSlugpopupdata] = useState({
        slugname: "",
        slug: "",
        units: 0,
    });
    const [open, setOpen] = React.useState(false);
    const [isLoginModalOpen, setLoginModalOpen] = useState(false);
    const [severity, setSeverity] = useState("info");
    const handleClose = () => setOpen(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [unit, setUnit] = useState("");
    const [selectedOption, setSelectedOption] = useState([]);
    const [options, setOptions] = useState([]);
    const [price, setPrice] = useState("");
    const [snackbaropen, setSnackbaropen] = React.useState(false);
    const closesnackbar = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setSnackbaropen(false);
    };
    const [totalUnits, setTotalUnits] = useState(0);
    const [selectedDate, handleDateChange] = useState("");
    const [Usablewallet, setUsablewallet] = useState("");
    const [showAlert, setShowAlert] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [buySell, setbuySell] = React.useState("");
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [newOptionValue, setNewOptionValue] = useState("");
    const [dataslug, setdataslug] = useState("");
    const [msgforUpdatePortfolio, setMsgforUpdatePortfolio] = useState("loading...");
    const mediaQueryVar = useMediaQuery(
        json2mq({
            minWidth: 900,
        })
    );
    const handleChange2 = (e) => {
        const value = e.target.value;
        // Check if the input contains a hyphen
        if (value.includes("-")) {
            setShowAlert(true); // Show the alert if there's a hyphen
        } else {
            setShowAlert(false); // Hide the alert if there's no hyphen
            setNewOptionValue(value); // Update the state with the new value
        }
    };
    const formatToNonZero = (number) => {
        number = parseFloat(number);

        if (number >= 1) {
            return number.toFixed(2);
        } else if (number >= 0.1) {
            return number.toFixed(1);
        } else if (number >= 0.01) {
            return number.toFixed(4);
        } else if (number >= 0.001) {
            return number.toFixed(5);
        } else if (number >= 0.0001) {
            return number.toFixed(6);
        } else if (number >= 0.00001) {
            return number.toFixed(7);
        } else if (number >= 0.000001) {
            return number.toFixed(8);
        } else if (number >= 0.0000001) {
            return number.toFixed(9);
        } else if (number >= 0.00000001) {
            return number.toFixed(10);
        } else if (number >= 0.000000001) {
            return number.toFixed(11);
        }
        return number.toFixed(1);
    };
    const handleDialogSubmit = () => {

        // Update options state with the new option
        const newOption = {value: newOptionValue, label: newOptionValue};
        setOptions([...options, newOption]);
        setSelectedOption(newOption);
        // Close the dialog
        setIsDialogOpen(false);

        // setSelectedOption(selectedOption);
        const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
        getTotalunit({
            user_id: userData.user_id,
            slug: dataslug, // Assuming value contains the slug
            portfolio_type_id: newOption.value, // Adjust as needed
            Token: userData.token,
        }).then((res) => {
            if (res.code === "200") {
                setTotalUnits(res.total_uint);
                setNewOptionValue("");
                setUsablewallet(res.wallet_amount);
            } else {
                console.log("Data fething error");
            }
        });
    };

    const fetchDropdownOptions = async () => {
        const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));

        getFetchdropdown({
            user_id: userData.user_id,
            Token: userData.token,
        }).then((res) => {
            if (res.code === "200") {
                const newOptions = res.data.map((item) => ({
                    value: item.id,
                    label: item.name,
                }));
                setOptions(newOptions);
                setuser_role(res.user_role);

                // Set the last option as the default selected option
                if (newOptions.length > 0) {
                    setSelectedOption(newOptions[newOptions.length - 1]);
                    console.log("is contain",newOptions[newOptions.length - 1], slugpopupdata.slugname);
                    handleChange(newOptions[newOptions.length - 1], slugpopupdata.slugname);
                }
            } else {
                console.log("Data fetching error");
            }
        });
    };

    useEffect(() => {
        if (slugpopupdata) {
            fetchDropdownOptions();
        }
    }, [slugpopupdata]);

    const handleClick = (buySell) => {
        setSnackbaropen(true);
        setOpen(true);
        setSeverity("info");
        setIsFormSubmitted(false);
        setMsgforUpdatePortfolio("loading...");
        const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
        const portfolioId =
            selectedOption && !isNaN(parseInt(selectedOption.value)) ? parseInt(selectedOption.value) : 0;
        const existingPortfolio = portfolioId > 0 ? "yes" : "no"; // Determine existing_portfolio based on portfolioId

        addToPortfolio({
            portfolio_type_id: portfolioId,
            portfolio_name: selectedOption ? selectedOption.label : "", // Ensure selectedOption is defined

            existing_portfolio: existingPortfolio,
            user_id: userData.user_id,
            slug: slugpopupdata.slugname,
            unit: unit,
            acquisition_price: price,
            date_time: selectedDate,
            type: buySell,
            Token: userData.token,
        }).then((res) => {
            if (res.code === "200") {
                // setOpen(false);
                setSeverity("info");
                //console.log(res.message);
                setMsgforUpdatePortfolio(res.message);
                setPortfolioTypeId(res.portfolio_type_id);
                setIsFormSubmitted(true);
                // navigate(
                //   `/my-portfolio/${res.portfolio_type_id}/${encodeURIComponent(
                //     selectedOption.label
                //   )}`
                // );
            } else {
                setSeverity("error");
                // setOpen(true)
                setMsgforUpdatePortfolio(res.message);
            }
        });
    };

    const handleAddToPortfolio = (idx) => {
        getCryporCurrencyListHome({
            slug: idx,
            pathname: "audit-my-portfolio",
            start_index: 0,
            limit: "20",
        }).then((res) => {
            if (res.code === "200") {
                // Update slugdata
                //setSlugdata(res.data);
                setuser_role(res.user_role);
                
                // Use res.data directly here
                const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
                if (userData) {
                    setSlugpopupdata({
                        slugname: res.data[0].slug,
                        slug: res.data[0].name,
                        units: res.data[0].total_unit,
                        pricetoday: res.data[0].price_today,
                        logo: res.data[0].logo,
                    });
                    setOpen(true);
                } else {
                    // Save the source in sessionStorage
                    const originalUrl = window.location.pathname + window.location.search;
                    sessionStorage.setItem("originalUrl", originalUrl);

                    // Before redirecting to login
                    sessionStorage.setItem("loginFromAddToPortfolio", "true");
                    sessionStorage.setItem(
                        "slugDataForPortfolio",
                        JSON.stringify({
                            slugname: res.data[0].slug,
                            slug: res.data[0].name,
                            units: res.data[0].total_unit,
                            pricetoday: res.data[0].price_today,
                            logo: res.data[0].logo,
                        })
                    );

                    window.history.pushState({}, "", "/login");
                    localStorage.setItem("isPopupManuallyOpened", "true");
                    
                    setLoginModalOpen(true);
                }
            } else {
                console.error("Data fetching error");
            }
        });
    };

    const handleChange = async (selectedOption, slug) => {
        if (selectedOption && selectedOption._isNew_) {
            setIsDialogOpen(true);
            setSelectedOption(null);
            setdataslug(slug);
        } else if (!selectedOption) {
            // Handle the case when the selection is cleared
            setSelectedOption(null);
            setShowAlert(false);
            // Perform any other necessary actions
            return;
        } else {
            const selectedValue = selectedOption.value;
            if (selectedValue.includes("-")) {
                setErrorMessage("Hyphens are not allowed in the option."); // Set error message
                setShowAlert(true); // Show the alert
                return; // Abort further processing
            }
            setShowAlert(false);
            setSelectedOption(selectedOption);
            const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
            if (!slug || !selectedOption){
                return;
            }
            getTotalunit({
                user_id: userData.user_id,
                slug: slug, // Assuming value contains the slug
                portfolio_type_id: selectedOption.value, // Adjust as needed
                Token: userData.token,
            }).then((res) => {
                if (res.code === "200") {
                    setTotalUnits(res.total_uint);
                    setUsablewallet(res.wallet_amount);
                } else {
                    console.log("Data fething error");
                }
                // console.log(slugdata)
            });
        }
    };
    const handleCreate = async (inputValue) => {
        setTotalUnits(0);
        setUsablewallet("");

        if (options.find((option) => option.value === inputValue)) {
            return; // Exit early if the option already exists
        }
        const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
        //console.log(inputValue);
        const newOption = {value: inputValue, label: inputValue};
        const newOptions = [...options, newOption]; // Create a new array with the existing options plus the new one
        setOptions(newOptions); // Update the options state
        const createdOption = newOptions.find((option) => option.value == inputValue);
        // console.log(createdOption);
        if (createdOption) {
            handleChange(createdOption,  slugpopupdata.slugname);
        }
    };

    const handleModalClose = () => {
        // Close the modal and reset the URL to the current page
        setLoginModalOpen(false);
        navigate(location.pathname, {replace: true});
    };

    return (
        <>
            {/* Trigger Button passed as a prop, inject handler */}
            <div onClick={() => handleAddToPortfolio(slugName)}>{triggerElement}</div>

            {isLoginModalOpen && (
                <LoginPopUp
                    isLoginModalOpen={isLoginModalOpen}
                    setLoginModalOpen={setLoginModalOpen} // Pass the state setter down
                    onClose={handleModalClose}
                />
            )}

            {mediaQueryVar ? (
                <>
                    {/* Modal shown when setOpen is true */}
                    <Modal
                        sx={{overflow: "hidden"}}
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <div className="CardOpener" style={{overflow: "hidden"}}>
                            {isFormSubmitted ? (
                                <Card className="card__container">
                                    <>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }}
                                        >
                                            <CheckCircleOutlineIcon sx={{fontSize: 50, mr: 1}} />
                                        </div>
                                        <Typography
                                            severity="success"
                                            sx={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }}
                                        >
                                            Portfolio added successfully!
                                        </Typography>
                                    </>
                                    <div style={{display: "flex", justifyContent: "space-evenly"}}>
                                        <Button
                                            onClick={() => {
                                                setIsFormSubmitted(false);
                                                setOpen(false);
                                                setUnit("");
                                                setSelectedOption("");
                                                setPrice("");
                                                setTotalUnits(0);
                                                handleDateChange("");
                                                setUsablewallet("");
                                            }}
                                            color="primary"
                                            style={{
                                                backgroundColor: "rgba(67, 97, 238, 0.15)",
                                                borderRadius: "6px",
                                                border: "none",
                                                textTransform: "none",
                                                borderStyle: "solid",
                                                borderColor: "rgba(67, 97, 238, 0.15)",
                                                borderWidth: "1px",
                                                color: "#4361ee",
                                                whiteSpace: "nowrap",
                                                float: "inline-end",
                                                width: mediaQueryVar === true ? "150px" : "100px",
                                                height: mediaQueryVar === false ? "30px" : "",
                                                fontSize: mediaQueryVar === false ? "10px" : "11px",
                                            }}
                                        >
                                            Add More Cryptos
                                        </Button>
                                        <Button
                                            onClick={() =>
                                                navigate(
                                                    `/my-portfolio/${portfolioTypeId}/${encodeURIComponent(
                                                        selectedOption.label.replace(/\s+/g, "-")
                                                    )}`
                                                )
                                            }
                                            variant="outlined"
                                            style={{
                                                backgroundColor: "rgba(67, 97, 238, 0.15)",
                                                borderRadius: "6px",
                                                border: "none",
                                                textTransform: "none",
                                                borderStyle: "solid",
                                                borderColor: "rgba(67, 97, 238, 0.15)",
                                                borderWidth: "1px",
                                                color: "#4361ee",
                                                whiteSpace: "nowrap",
                                                float: "inline-end",
                                                width: mediaQueryVar === true ? "100px" : "100px",
                                                height: mediaQueryVar === false ? "30px" : "",
                                                fontSize: mediaQueryVar === false ? "10px" : "11px",
                                            }}
                                            color="primary"
                                        >
                                            View Portfolio
                                        </Button>
                                    </div>
                                </Card>
                            ) : (
                                <Dialog
                                    PaperProps={{
                                        sx: {
                                            position: mediaQueryVar ? "static" : "fixed",
                                            bottom: mediaQueryVar ? "" : 0,
                                            left: mediaQueryVar ? "" : 0,
                                            right: mediaQueryVar ? "" : 0,
                                            marginTop: "1%",
                                            maxWidth: "100%",
                                            minHeight: "60%", // Adjust max height if needed
                                            borderRadius: mediaQueryVar ? "24px" : "24px 24px 0 0",
                                            padding: "10px",
                                            alignItems: "center",
                                            overflow: "scroll",
                                            "&::-webkit-scrollbar": {
                                                display: "none",
                                            },
                                            "-ms-overflow-style": "none",
                                            "scrollbar-width": "none", // Ensure no scrollbar
                                        },
                                    }}
                                    open={open}
                                    onClose={handleClose}
                                >
                                    <div style={{padding: "20px", width: "400px", margin: "0", marginTop: "-5px"}}>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                marginBottom: "20px",
                                                borderBottom: "1px #E3E3E3 solid",
                                            }}
                                        >
                                            <Typography
                                                style={{fontWeight: "500", fontSize: "20.767px", paddingLeft: "100px"}}
                                                gutterBottom
                                            >
                                                {headingText}
                                            </Typography>

                                            <div className="primaryButton">
                                                <img
                                                    className="frameIcon"
                                                    alt="frameIcon"
                                                    onClick={handleClose}
                                                    src={window.constants.asset_path + "/images/frame17.svg"}
                                                    style={{background: "#F3F3F3", width: "25px", height: "25px"}}
                                                />
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                marginBottom: "5px",
                                                marginLeft: mediaQueryVar === false ? "10px" : "",
                                            }}
                                        >
                                            <Typography
                                                style={{
                                                    fontSize: "13.845px",
                                                    fontWeight: "500",
                                                    marginBottom: "1px",
                                                    color: "black",
                                                    marginTop: "-8px",
                                                }}
                                            >
                                                Select Portfolio
                                            </Typography>
                                            <div style={{marginTop: "5px"}}>
                                                <CreatableSelect
                                                    isClearable
                                                    styles={{
                                                        control: (provided) => ({
                                                            ...provided,
                                                            borderRadius: "12px",
                                                            border: "1px solid #1877F2",
                                                            boxShadow: "none",
                                                            minHeight: "40px",
                                                            "&:hover": {
                                                                borderRadius: "12px",
                                                                border: "2px solid #1877F2",
                                                            },
                                                        }),
                                                        menu: (provided) => ({
                                                            ...provided,
                                                            borderRadius: "8px",
                                                        }),
                                                        placeholder: (provided) => ({
                                                            ...provided,
                                                            color: "",
                                                        }),
                                                        dropdownIndicator: (provided) => ({
                                                            ...provided,
                                                            color: "#1877F2",
                                                            border: "1px solid #1877F2",
                                                            padding: "5px",
                                                            margin: "8px",
                                                            borderRadius: "3.786px",
                                                            "&:hover": {
                                                                color: "#1877F2",
                                                            },
                                                        }),
                                                        indicatorSeparator: (provided) => ({
                                                            display: "none",
                                                        }),
                                                    }}
                                                    placeholder=""
                                                    onChange={(options) =>
                                                        handleChange(options, slugpopupdata.slugname)
                                                    }
                                                    onCreateOption={handleCreate}
                                                    options={[
                                                        {value: "", label: "Create new portfolio", _isNew_: true}, // Dynamic "create new option" item
                                                        ...options, // Existing options
                                                    ]}
                                                    value={selectedOption}
                                                />
                                            </div>
                                            {showAlert && (
                                                <Alert severity="error" sx={{marginBottom: "10px"}}>
                                                    {errorMessage}
                                                </Alert>
                                            )}
                                        </div>
                                        <Typography
                                            style={{
                                                fontSize: "13.845px",
                                                fontWeight: "500",
                                                color: "#000",
                                                marginTop: "10px",
                                                marginBottom: "5px",
                                            }}
                                        >
                                            Usable Wallet Value: {Usablewallet}
                                        </Typography>
                                        <div
                                            style={{
                                                padding: "8px",
                                                background: "#F3F3F3",
                                                borderRadius: "8px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <div style={{display: "flex", alignItems: "center", flex: 0, minWidth: 0}}>
                                                <img
                                                    style={{
                                                        marginRight: "10px",
                                                        border: "2px solid #000",
                                                        borderRadius: "19px",
                                                        height: "27.69px",
                                                        width: "27.69px",
                                                    }}
                                                    alt="logo"
                                                    src={slugpopupdata.logo}
                                                />
                                                <div style={{display: "flex", flexDirection: "column"}}>
                                                    <Typography
                                                        sx={{
                                                            fontWeight: "500",
                                                            marginBottom: "4px",
                                                            fontSize: "14px",
                                                            color: "#7F7F80",
                                                        }}
                                                    >
                                                        {slugpopupdata.slugname}
                                                    </Typography>
                                                </div>
                                            </div>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    marginLeft: "23%",
                                                    flex: 1,
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        fontWeight: "500",
                                                        marginBottom: "4px",
                                                        fontSize: "13px",
                                                        color: "#7F7F80",
                                                    }}
                                                >
                                                    {" "}
                                                    Price
                                                </Typography>
                                                <Typography
                                                    sx={{
                                                        fontSize: "12.114px",
                                                        fontWeight: "500",
                                                        color: "black",
                                                        margin: "0",
                                                        marginLeft: "15px",
                                                    }}
                                                >
                                                    {slugpopupdata.pricetoday}
                                                </Typography>
                                            </div>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    marginLeft: "20px",
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        fontWeight: "500",
                                                        marginBottom: "4px",
                                                        fontSize: "13px",
                                                        color: "#7F7F80",
                                                    }}
                                                >
                                                    {" "}
                                                    Units
                                                </Typography>
                                                <Typography
                                                    sx={{
                                                        fontSize: "12.114px",
                                                        fontWeight: "500",
                                                        color: "black",
                                                        margin: "0",
                                                    }}
                                                >
                                                    
                                                    {totalUnits}
                                                </Typography>
                                            </div>
                                        </div>
                                        <div className="card__container__row3">
                                            <div style={{marginLeft: "-5px"}}>
                                                <p style={{fontSize: "14px", fontWeight: "500"}}>
                                                    Enter number of Units
                                                </p>
                                                <input
                                                    style={{
                                                        backgroundColor: "white",
                                                        color: "black",
                                                        padding: "20px",
                                                        border: "1px solid #1877F2",
                                                        borderRadius: "10.384px",
                                                        width: "350px",
                                                        height: "45px",
                                                        margin: 0,
                                                    }}
                                                    min="1"
                                                    max="10"
                                                    type="number"
                                                    placeholder=""
                                                    value={unit}
                                                    onChange={(e) => setUnit(e.target.value)}
                                                ></input>
                                            </div>
                                            <div>
                                                $
                                                {formatToNonZero(
                                                    unit *
                                                        parseFloat((slugpopupdata.pricetoday || "").replace(/^\$/, ""))
                                                )}
                                            </div>
                                            {user_role === "superuser" && (
                                                <>
                                                    <div className="card__container__row3__r2">
                                                        <div style={{marginLeft: "-5px"}}>
                                                            <p style={{fontSize: "14px", fontWeight: "500"}}>
                                                                Buy/Sell Price($)
                                                            </p>
                                                            <input
                                                                style={{
                                                                    backgroundColor: "white",
                                                                    color: "black",
                                                                    padding: "20px",
                                                                    border: "1px solid #1877F2",
                                                                    borderRadius: "10.384px",
                                                                    width: "345px",
                                                                    height: "45px",
                                                                }}
                                                                className="card__container__row3__r2__input"
                                                                min="1"
                                                                max="10"
                                                                type="number"
                                                                placeholder="Enter Price"
                                                                value={price}
                                                                onChange={(e) => setPrice(e.target.value)}
                                                            ></input>
                                                        </div>
                                                    </div>
                                                    <div style={{marginBottom: "10px", marginLeft: "-5px"}}>
                                                        <p style={{fontSize: "14px", fontWeight: "500"}}>Date</p>
                                                        <TextField
                                                            type="date"
                                                            value={selectedDate}
                                                            onChange={(e) => handleDateChange(e.target.value)}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            sx={{
                                                                "& .MuiOutlinedInput-root": {
                                                                    borderRadius: "10.384px",
                                                                    border: "1px solid #1877F2",
                                                                    boxShadow: "none",
                                                                    width: "190%",
                                                                    height: "45px",
                                                                },
                                                            }}
                                                        />
                                                    </div>
                                                </>
                                            )}
                                            <div className="card__container__row3__r4" style={{marginTop: "10px"}}>
                                                <Button
                                                    className={
                                                        buySell === "buy" ? "buttonToggleButActive" : "buttonToggleBuy"
                                                    }
                                                    value="Buy"
                                                    style={{
                                                        lineHeight: "20px",
                                                        width: "159px",
                                                        borderRadius: "27px",
                                                        border: "1px solid #1877F2",
                                                        padding: "15px 85px",
                                                        marginLeft: "-10px",
                                                        backgroundColor: buySell === "buy" ? "" : "#1877F2",
                                                        color: buySell === "buy" ? "" : "white",
                                                        textTransform: "none",
                                                        fontSize: "18px",
                                                        fontWeight: "700",
                                                    }}
                                                    onClick={() => handleClick("buy")}
                                                >
                                                    Add
                                                </Button>
                                                <Button
                                                    className={
                                                        buySell === "sell"
                                                            ? "buttonToggleSellActive"
                                                            : "buttonToggleSell"
                                                    }
                                                    value="sell"
                                                    style={{
                                                        lineHeight: "20px",
                                                        width: "159px",
                                                        borderRadius: "27px",
                                                        border: "1px solid #1877F2",
                                                        marginLeft: "10px",
                                                        padding: "15px 85px",
                                                        backgroundColor: buySell === "sell" ? "" : "#1877F2",
                                                        color: buySell === "sell" ? "" : "white",
                                                        textTransform: "none",
                                                        fontSize: "18px",
                                                        fontWeight: "700",
                                                    }}
                                                    onClick={() => handleClick("sell")}
                                                >
                                                    Remove
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </Dialog>
                            )}
                        </div>
                    </Modal>

                    <Dialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)} fullWidth maxWidth="sm">
                        <DialogTitle>
                            Create New Portfolio
                            <IconButton
                                aria-label="close"
                                onClick={() => {
                                    setIsDialogOpen(false);
                                    setNewOptionValue("");
                                }}
                                sx={{position: "absolute", right: 13, top: 8}}
                            >
                                <CloseIcon />
                            </IconButton>
                        </DialogTitle>
                        <DialogContent>
                            <div>
                                <TextField
                                    autoFocus
                                    label="Enter Name"
                                    value={newOptionValue}
                                    onChange={handleChange2}
                                    fullWidth
                                    margin="dense"
                                />
                                {showAlert && (
                                    <Alert severity="error" sx={{marginTop: "8px"}}>
                                        Hyphens are not allowed in the name.
                                    </Alert>
                                )}
                            </div>
                        </DialogContent>
                        <DialogActions sx={{marginRight: "14px"}}>
                            <Button
                                onClick={() => {
                                    setIsDialogOpen(false);
                                    setNewOptionValue("");
                                }}
                                sx={{fontWeight: "bold"}}
                                variant="outlined"
                                color="primary"
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={handleDialogSubmit}
                                variant="contained"
                                color="primary"
                                sx={{fontWeight: "bold"}}
                                disabled={!newOptionValue.trim()}
                            >
                                Submit
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Snackbar
                        open={snackbaropen}
                        autoHideDuration={5000}
                        onClose={closesnackbar}
                        anchorOrigin={{vertical: "bottom", horizontal: "center"}}
                    >
                        <Alert severity={severity}>{msgforUpdatePortfolio}</Alert>
                    </Snackbar>
                </>
            ) : (
                <>
                    <Modal
                        sx={{overflow: "hidden"}}
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <div className="CardOpener" style={{overflow: "hidden"}}>
                            {isFormSubmitted ? (
                                <Card className="card__container">
                                    <>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }}
                                        >
                                            <CheckCircleOutlineIcon sx={{fontSize: 50, mr: 1}} />
                                        </div>
                                        <Typography
                                            severity="success"
                                            sx={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }}
                                        >
                                            Portfolio added successfully!
                                        </Typography>
                                    </>
                                    <div style={{display: "flex", justifyContent: "space-evenly"}}>
                                        <Button
                                            onClick={() => {
                                                setIsFormSubmitted(false);
                                                setOpen(false);
                                                setUnit("");
                                                setSelectedOption("");
                                                setPrice("");
                                                setTotalUnits(0);
                                                handleDateChange("");
                                                setUsablewallet("");
                                            }}
                                            color="primary"
                                            style={{
                                                backgroundColor: "rgba(67, 97, 238, 0.15)",
                                                borderRadius: "6px",
                                                border: "none",
                                                textTransform: "none",
                                                borderStyle: "solid",
                                                borderColor: "rgba(67, 97, 238, 0.15)",
                                                borderWidth: "1px",
                                                color: "#4361ee",
                                                whiteSpace: "nowrap",
                                                float: "inline-end",
                                                width: mediaQueryVar === true ? "150px" : "100px",
                                                height: mediaQueryVar === false ? "30px" : "",
                                                fontSize: mediaQueryVar === false ? "10px" : "11px",
                                            }}
                                        >
                                            Add More Cryptos
                                        </Button>
                                        <Button
                                            onClick={() =>
                                                navigate(
                                                    `/my-portfolio/${portfolioTypeId}/${encodeURIComponent(
                                                        selectedOption.label
                                                    )}`
                                                )
                                            }
                                            variant="outlined"
                                            style={{
                                                backgroundColor: "rgba(67, 97, 238, 0.15)",
                                                borderRadius: "6px",
                                                border: "none",
                                                textTransform: "none",
                                                borderStyle: "solid",
                                                borderColor: "rgba(67, 97, 238, 0.15)",
                                                borderWidth: "1px",
                                                color: "#4361ee",
                                                whiteSpace: "nowrap",
                                                float: "inline-end",
                                                width: mediaQueryVar === true ? "100px" : "100px",
                                                height: mediaQueryVar === false ? "30px" : "",
                                                fontSize: mediaQueryVar === false ? "10px" : "11px",
                                            }}
                                            color="primary"
                                        >
                                            View Portfolio
                                        </Button>
                                    </div>
                                </Card>
                            ) : (
                                <Dialog
                                    PaperProps={{
                                        sx: {
                                            position: mediaQueryVar ? "static" : "fixed",
                                            bottom: mediaQueryVar ? "" : 0,
                                            left: mediaQueryVar ? "" : 0,
                                            right: mediaQueryVar ? "" : 0,
                                            margin: "0",
                                            maxWidth: "100%",
                                            minHeight: "50%", // Adjust max height if needed
                                            borderRadius: mediaQueryVar ? "24px" : "24px 24px 0 0",
                                            padding: "10px",
                                            alignItems: "center",
                                            overflow: "scroll",
                                            "&::-webkit-scrollbar": {
                                                display: "none",
                                            },
                                            "-ms-overflow-style": "none",
                                            "scrollbar-width": "none", // Ensure no scrollbar
                                        },
                                    }}
                                    open={open}
                                    onClose={handleClose}
                                >
                                    <div
                                        style={{
                                            padding: "20px",
                                            width: mediaQueryVar === false ? "100%" : "400px",
                                            margin: "0",
                                            marginTop: "-5px",
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                marginBottom: "20px",
                                                borderBottom: "1px #E3E3E3 solid",
                                            }}
                                        >
                                            <Typography
                                                style={{fontWeight: "500", fontSize: "20.767px", paddingLeft: "25%"}}
                                                gutterBottom
                                            >
                                                Add To Portfolio
                                            </Typography>

                                            <div className="primaryButton">
                                                <img
                                                    className="frameIcon"
                                                    alt=""
                                                    onClick={handleClose}
                                                    src={window.constants.asset_path + "/images/frame17.svg"}
                                                    style={{background: "#F3F3F3", width: "25px", height: "25px"}}
                                                />
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                marginBottom: "5px",
                                                marginLeft: mediaQueryVar === false ? "5px" : "",
                                            }}
                                        >
                                            <Typography
                                                style={{
                                                    fontSize: "13.845px",
                                                    fontWeight: "500",
                                                    marginBottom: "1px",
                                                    color: "black",
                                                    marginTop: "-8px",
                                                }}
                                            >
                                                Select Portfolio
                                            </Typography>
                                            <div style={{marginTop: "5px"}}>
                                                <CreatableSelect
                                                    isClearable
                                                    styles={{
                                                        control: (provided) => ({
                                                            ...provided,
                                                            borderRadius: "12px",
                                                            border: "1px solid #1877F2",
                                                            boxShadow: "none",
                                                            minHeight: "40px",
                                                            "&:hover": {
                                                                borderRadius: "12px",
                                                                border: "2px solid #1877F2",
                                                            },
                                                        }),
                                                        menu: (provided) => ({
                                                            ...provided,
                                                            borderRadius: "8px",
                                                        }),
                                                        placeholder: (provided) => ({
                                                            ...provided,
                                                            color: "",
                                                        }),
                                                        dropdownIndicator: (provided) => ({
                                                            ...provided,
                                                            color: "#1877F2",
                                                            border: "1px solid #1877F2",
                                                            padding: "5px",
                                                            margin: "8px",
                                                            borderRadius: "3.786px",
                                                            "&:hover": {
                                                                color: "#1877F2",
                                                            },
                                                        }),
                                                        indicatorSeparator: (provided) => ({
                                                            display: "none",
                                                        }),
                                                    }}
                                                    placeholder=""
                                                    onChange={(options) =>
                                                        handleChange(options, slugpopupdata.slugname)
                                                    }
                                                    onCreateOption={handleCreate}
                                                    options={[
                                                        {value: "", label: "Create new portfolio", _isNew_: true}, // Dynamic "create new option" item
                                                        ...options, // Existing options
                                                    ]}
                                                    value={selectedOption}
                                                />
                                            </div>
                                            {showAlert && (
                                                <Alert severity="error" sx={{marginBottom: "10px"}}>
                                                    {errorMessage}
                                                </Alert>
                                            )}
                                        </div>
                                        <Typography
                                            style={{
                                                fontSize: "13.845px",
                                                fontWeight: "500",
                                                color: "#000",
                                                marginTop: "10px",
                                                marginBottom: "5px",
                                            }}
                                        >
                                            Usable Wallet Value: {Usablewallet}
                                        </Typography>
                                        <div
                                            style={{
                                                padding: "8px",
                                                background: "#F3F3F3",
                                                borderRadius: "8px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <div style={{display: "flex", alignItems: "center", flex: 0, minWidth: 0}}>
                                                <img
                                                    style={{
                                                        marginRight: "10px",
                                                        border: "2px solid #000",
                                                        borderRadius: "19px",
                                                        height: "27.69px",
                                                        width: "27.69px",
                                                    }}
                                                    alt=""
                                                    src={slugpopupdata.logo}
                                                />
                                                <div style={{display: "flex", flexDirection: "column"}}>
                                                    <Typography
                                                        sx={{
                                                            fontWeight: "500",
                                                            marginBottom: "4px",
                                                            fontSize: "14px",
                                                            color: "#7F7F80",
                                                        }}
                                                    >
                                                        {slugpopupdata.slugname}
                                                    </Typography>
                                                    <Typography
                                                        sx={{
                                                            fontSize: "14px",
                                                            fontWeight: "500",
                                                            color: "black",
                                                            margin: "0",
                                                        }}
                                                    >
                                                        {slugpopupdata.slug}
                                                    </Typography>
                                                </div>
                                            </div>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    marginLeft: "20px",
                                                    flex: 1,
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        fontWeight: "500",
                                                        marginBottom: "4px",
                                                        fontSize: "13px",
                                                        color: "#7F7F80",
                                                    }}
                                                >
                                                    {" "}
                                                    Price
                                                </Typography>
                                                <Typography
                                                    sx={{
                                                        fontSize: "12.114px",
                                                        fontWeight: "500",
                                                        color: "black",
                                                        margin: "0",
                                                    }}
                                                >
                                                    {slugpopupdata.pricetoday}
                                                </Typography>
                                            </div>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    marginLeft: "20px",
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        fontWeight: "500",
                                                        marginBottom: "4px",
                                                        fontSize: "13px",
                                                        color: "#7F7F80",
                                                    }}
                                                >
                                                    {" "}
                                                    Units
                                                </Typography>
                                                <Typography
                                                    sx={{
                                                        fontSize: "12.114px",
                                                        fontWeight: "500",
                                                        color: "black",
                                                        margin: "0",
                                                    }}
                                                >
                                                    {totalUnits}
                                                </Typography>
                                            </div>
                                        </div>
                                        <div className="card__container__row3">
                                            <div style={{marginLeft: "-5px"}}>
                                                <p style={{fontSize: "14px", fontWeight: "500"}}>
                                                    Enter number of Units
                                                </p>
                                                <input
                                                    style={{
                                                        backgroundColor: "white",
                                                        color: "black",
                                                        padding: "20px",
                                                        border: "1px solid #1877F2",
                                                        borderRadius: "10.384px",
                                                        width: "100%",
                                                        height: "45px",
                                                        margin: 0,
                                                    }}
                                                    min="1"
                                                    max="10"
                                                    type="number"
                                                    placeholder=""
                                                    value={unit}
                                                    onChange={(e) => setUnit(e.target.value)}
                                                ></input>
                                            </div>
                                            <div>
                                                $
                                                {formatToNonZero(
                                                    unit *
                                                        parseFloat((slugpopupdata.pricetoday || "").replace(/^\$/, ""))
                                                )}
                                            </div>
                                            {user_role === "superuser" && (
                                                <>
                                                    <div className="card__container__row3__r2">
                                                        <div style={{marginLeft: "-5px"}}>
                                                            <p style={{fontSize: "14px", fontWeight: "500"}}>
                                                                Buy/Sell Price($)
                                                            </p>
                                                            <input
                                                                style={{
                                                                    backgroundColor: "white",
                                                                    color: "black",
                                                                    padding: "20px",
                                                                    border: "1px solid #1877F2",
                                                                    borderRadius: "10.384px",
                                                                    width: "100%",
                                                                    height: "45px",
                                                                }}
                                                                className="card__container__row3__r2__input"
                                                                min="1"
                                                                max="10"
                                                                type="number"
                                                                placeholder="Enter Price"
                                                                value={price}
                                                                onChange={(e) => setPrice(e.target.value)}
                                                            ></input>
                                                        </div>
                                                    </div>
                                                    <div style={{marginBottom: "10px", marginLeft: "-5px"}}>
                                                        <p style={{fontSize: "14px", fontWeight: "500"}}>Date</p>
                                                        <TextField
                                                            type="date"
                                                            value={selectedDate}
                                                            onChange={(e) => handleDateChange(e.target.value)}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            sx={{
                                                                "& .MuiOutlinedInput-root": {
                                                                    borderRadius: "10.384px",
                                                                    border: "1px solid #1877F2",
                                                                    boxShadow: "none",
                                                                    width: "190%",
                                                                    height: "45px",
                                                                },
                                                            }}
                                                        />
                                                    </div>
                                                </>
                                            )}
                                            <div className="card__container__row3__r4" style={{marginTop: "10px"}}>
                                                <Button
                                                    className={
                                                        buySell === "buy" ? "buttonToggleButActive" : "buttonToggleBuy"
                                                    }
                                                    value="Buy"
                                                    style={{
                                                        lineHeight: "20px",
                                                        width: "45%",
                                                        borderRadius: "27px",
                                                        border: "1px solid #1877F2",
                                                        padding: "15px 8px",
                                                        marginLeft: "5px",
                                                        backgroundColor: buySell === "buy" ? "" : "#1877F2",
                                                        color: buySell === "buy" ? "" : "white",
                                                        textTransform: "none",
                                                        fontSize: "18px",
                                                        fontWeight: "700",
                                                    }}
                                                    onClick={() => handleClick("buy")}
                                                >
                                                    Add
                                                </Button>
                                                <Button
                                                    className={
                                                        buySell === "sell"
                                                            ? "buttonToggleSellActive"
                                                            : "buttonToggleSell"
                                                    }
                                                    value="sell"
                                                    style={{
                                                        lineHeight: "20px",
                                                        width: "45%",
                                                        borderRadius: "27px",
                                                        border: "1px solid #1877F2",
                                                        marginLeft: "5px",
                                                        marginRight: "10px",
                                                        padding: "15px 8px",
                                                        backgroundColor: buySell === "sell" ? "" : "#1877F2",
                                                        color: buySell === "sell" ? "" : "white",
                                                        textTransform: "none",
                                                        fontSize: "18px",
                                                        fontWeight: "700",
                                                    }}
                                                    onClick={() => handleClick("sell")}
                                                >
                                                    Remove
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </Dialog>
                            )}
                        </div>
                    </Modal>
                    <Dialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)} fullWidth maxWidth="sm">
                        <DialogTitle>
                            Create New Portfolio
                            <IconButton
                                aria-label="close"
                                onClick={() => {
                                    setIsDialogOpen(false);
                                    setNewOptionValue("");
                                }}
                                sx={{position: "absolute", right: 13, top: 8}}
                            >
                                <CloseIcon />
                            </IconButton>
                        </DialogTitle>
                        <DialogContent>
                            <div>
                                <TextField
                                    autoFocus
                                    label="Enter Name"
                                    value={newOptionValue}
                                    onChange={handleChange2}
                                    fullWidth
                                    margin="dense"
                                />
                                {showAlert && (
                                    <Alert severity="error" sx={{marginTop: "8px"}}>
                                        Hyphens are not allowed in the name.
                                    </Alert>
                                )}
                            </div>
                        </DialogContent>
                        <DialogActions sx={{marginRight: "14px"}}>
                            <Button
                                onClick={() => {
                                    setIsDialogOpen(false);
                                    setNewOptionValue("");
                                }}
                                sx={{fontWeight: "bold"}}
                                variant="outlined"
                                color="primary"
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={handleDialogSubmit}
                                variant="contained"
                                color="primary"
                                sx={{fontWeight: "bold"}}
                                disabled={!newOptionValue.trim()}
                            >
                                Submit
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Snackbar
                        open={snackbaropen}
                        autoHideDuration={5000}
                        onClose={closesnackbar}
                        anchorOrigin={{vertical: "bottom", horizontal: "center"}}
                    >
                        <Alert severity={severity}>{msgforUpdatePortfolio}</Alert>
                    </Snackbar>
                </>
            )}
        </>
    );
};

export default AddToPortfolioPopup;
